import { createAuthClient } from 'better-auth/react';

import { API_URL } from './config.js';

/**
 * Better Auth client (docs/07 §5). Cookies travel with `credentials: 'include'`; web and API are
 * the same site (same host, different port in development; `app.` and `api.` subdomains in
 * production), so the `SameSite=Lax` session cookie is sent.
 */
export const authClient = createAuthClient({
  baseURL: API_URL || undefined,
  fetchOptions: { credentials: 'include' },
});

export type Session = NonNullable<ReturnType<typeof authClient.useSession>['data']>;
